<template>
    <gestion>
        <div class="space-y-6 sm:px-6 lg:px-0 lg:col-span-9">
            <section aria-labelledby="payment_details_heading">
                <mailchimp
                    :initial-integration="mailchimp"
                    class="shadow sm:rounded-md sm:overflow-hidden"
                    :submit-text="$t('forms.account.save')"
                    @updated="updated"
                />
            </section>
        </div>
    </gestion>
</template>

<script>
    import Gestion from '@/layouts/Gestion.vue';
    import Mailchimp from '@/components/forms/Mailchimp.vue';

    export default {
        components: {
            Mailchimp,
            Gestion,
        },

        props: {
            integrations: {
                type: Array,
                default: () => [],
            },
        },

        computed: {
            mailchimp() {
                return this.integrations.find(integration => integration.id == 1) || {};
            },
        },

        methods: {
            updated() {
                this.$notify.success(this.$t('general.editsaved'));
            },
        },
    };
</script>
